import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'sortByIndex',
})
export class SortByIndexPipe implements PipeTransform {
  transform(value: Array<{ key: string; value: any }>, ...args: unknown[]): Array<{ key: string; value: any }> {
    let array = [...value];
    array.sort((a, b) => {
      let numA = Number(a.key);
      let numB = Number(b.key);
      return numA - numB;
    });
    return array;
  }
}
